import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MyAccountRoutingModule } from "./my-account-routing.module";
import { MyProfileComponent } from "./my-profile/my-profile.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { MyAccountComponent } from "./my-account.component";
import { NavigationModule } from "../navigation/navigation.module";
import { EditProfileComponent } from "./my-profile/edit-profile/edit-profile.component";
import { OtpModelComponent } from "./my-profile/edit-profile/otp-model/otp-model.component";
import { MySubscriptionComponent } from "./my-subscription/my-subscription.component";
import { FormsModule } from "@angular/forms";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { MyAccountService } from "./my-account.service";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { NgxSpinnerModule } from "ngx-spinner";
import { RecaptchaModule } from "angular-google-recaptcha";
import { SavedCardComponent } from "./saved-card/saved-card.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule, MatRippleModule } from "@angular/material/core";
import { MatRadioModule } from "@angular/material/radio";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { Ng2TelInputModule } from "ng2-tel-input";
import { NgOtpInputModule } from "ng-otp-input";
import { PurchaseHistoryComponent } from "./purchase-history/purchase-history.component";
import { PipeModule } from "../pipemodule/pipe.module";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
import { CarouselModule } from "ngx-owl-carousel-o";
import { GridComponent } from "../base/grid/grid.component";
import { BaseModule } from "../base/base.module";
import { ImgFallbackModule } from "ngx-img-fallback";

@NgModule({
  declarations: [
    MyProfileComponent,
    SidebarComponent,
    MyAccountComponent,
    EditProfileComponent,
    MySubscriptionComponent,
    ChangePasswordComponent,
    SavedCardComponent,
    OtpModelComponent,
    PurchaseHistoryComponent,
  ],
  imports: [
    BaseModule,
    CarouselModule,
    CommonModule,
    MyAccountRoutingModule,
    MatDatepickerModule,
    NavigationModule,
    FormsModule,
    HttpClientModule,
    NgxSpinnerModule,
    MatNativeDateModule,
    MatRippleModule,
    MatRadioModule,
    Ng2TelInputModule,
    NgOtpInputModule,
    PipeModule,
    ImgFallbackModule,
    RecaptchaModule.forRoot({
      siteKey: "6Ldm6q8eAAAAAH4OI3M_pGMTPYS5HdtyrdeGVYtY",
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    MyAccountService,
    MyProfileComponent,
    MySubscriptionComponent,
    ChangePasswordComponent,
    SidebarComponent,
  ],
  exports: [GridComponent],
})
export class MyAccountModule {}
